module.exports = __webpack_public_path__ + "img/crop-02.71bd3ff6.svg";